// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__yns0r","text":"ErrorPage_text__zxl4Z","reason":"ErrorPage_reason__e3DVc","btn_back":"ErrorPage_btn_back__3LWkG"};